module.exports = __webpack_public_path__ + "img/avatar.cc6357c9.png";